<template>
  <section id="projects" class="container mt4">
    <div class="subhead">projects</div>
    <h2 class="h2 serif fw700 mtq">Making a unique impact.</h2>
    <tab name="" selected="true">
      <div class="project-section-justice container-main">
        <div class="project cols-6">
          <h3 class="h3 serif fw700 color-gray7 mt2">Technology and Undercover Operations</h3>
          <p class="small-p mt1"><b>Project Goals:</b> Use a mixture of bleeding-edge technology and well trained HUMINT operatives to investigate, infiltrate, disrupt, and destroy criminal enterprises engaged in preying on the vulnerable. Our focus is human trafficking and child pornography.</p>
          <p class="small-p mt1"><b>What it looks like:</b> Working closely with government agencies. Managing and running bleeding- edge AI (artificial intelligence) servers. Sending operatives to infiltrate criminal organizations. Software development in the darknet.</p>
        </div>
        <div class="project cols-6">
          <h3 class="h3 serif fw700 color-gray7 mt2">Secret Agents of Grace</h3>
          <p class="small-p mt1"><b>Project Goals:</b> Recruit and empower people who interface with those on their worst days (bartenders, nurses, pharmacists, etc) to use basic HUMINT techniques to spread God's love and grace intelligently and effectively on an individual basis. </p>
          <p class="small-p mt1"><b>What it looks like:</b> Counseling and encouraging individuals in bars, hospitals, street corners through counseling and HUMINT techniques. Building relationships with the intention to change lives. Giving away gift cards, letters, or other small gifts to maximize emotional impact. </p>
        </div>
        <div class="project cols-6">
          <h3 class="h3 serif fw700 color-gray7 mt2">Strategic Partnerships and Training</h3>
          <p class="small-p mt1"><b>Project Goals:</b> Train and empower churches and communities with HUMINT techniques to spread the gospel practically and effectively by identifying and restoring the hurting among them. </p>
          <p class="small-p mt1"><b>What it looks like:</b> Working with churches to train their congregations (with a focus on youth) in HUMINT techniques. Encouraging and equipping church leadership to incorporate effective discipleship models into their mission. </p>
        </div>
        <div class="project cols-6">
          <h3 class="h3 serif fw700 color-gray7 mt2">Agents of Change</h3>
          <p class="small-p mt1"><b>Project Goals:</b> Send well-trained agents into areas of suffering (including homeless camps, foster care organizations, high-crime communities, etc) to alleviate suffering and enable individuals to change their lives. </p>
          <p class="small-p mt1"><b>What it looks like:</b> Building individual relationships with hurting and vulnerable people. Help them navigate available resources - and advocate for them when needed. Counseling and HUMINT techniques to build emotional impact through relationships and advocacy.</p>
        </div>
      </div>
    </tab>

  </section>
</template>

<script>
import Tabs from '@/components/ui/Tabs.vue'
import Tab from '@/components/ui/Tab.vue'

export default {
  components: {
    Tabs,
    Tab
  }
}
</script>

<style lang="scss">
@import '~@/styles/colors';
@import '~@/styles/media';

.project-tabs .tabs ul {
  display: flex;
  flex-wrap: wrap;
}

.project-tabs .tab {
  width: 50%;
  font-size: 0.75em;
  line-height: 3em;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  background-color: map-get($colors, cyan0);
  border: 2px solid #fff;
  white-space: nowrap;
  cursor: pointer;

  &.isActive {
    background-color: map-get($colors, cyan2);

    a {
      color: map-get($colors, gray9);
    }
  }

  a {
    color: map-get($colors, cyan9);
  }

  @include md {
    width: auto;
    margin-right: 0.5rem;
    padding: 0.5rem 1rem;
    line-height: 1em;
    border-radius: 0.5rem;
    background-color: unset;

    &:hover {
      background-color: map-get($colors, cyan0);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Projects.vue